import { useSyncExternalStore } from 'react';
import { getAuth, subscribe, hasPermission } from './permissions';

/** Current auth user (re-renders on login/logout). */
export function useAuth() {
  return useSyncExternalStore(subscribe, getAuth, getAuth);
}

/** Returns can(module, action) bound to the current user. */
export function useCan() {
  const user = useAuth();
  return (module, action) => hasPermission(user, module, action);
}
